/**
 * The four figures at the top of the Channels view.
 *
 * Missing and confirmed-zero values both use the dashboard's em-dash display
 * convention. The API still preserves null versus numeric zero so downstream
 * readers do not lose the distinction.
 */

import React from 'react';
import { Panel, Button, Select } from '@cloudsam/ui';

const show = (v) => (v === null || v === undefined || v === '' || v === 0 ? '—' : v);

export default function SummaryPanel({
    period = 'month',
    periodLabel,
    onPeriodChange,
    bindingsActive,
    bindingsTotal,
    messagesSent,
    surveyCount,
    spend,
    liveNow,
    usageIncomplete = false,
}) {
    return (
        <Panel
            title={period === 'year_to_date' ? 'Year to date' : 'This month'}
            count={periodLabel}
            controls={(
                <Select
                    className="summary-period-select"
                    aria-label="Summary period"
                    value={period}
                    onChange={(event) => onPeriodChange?.(event.target.value)}
                >
                    <option value="month">This month</option>
                    <option value="year_to_date">Year to date</option>
                </Select>
            )}
            className="summary-panel"
            bodyClassName="kpi-row"
            actions={<Button variant="ghost">Export ▾</Button>}
        >
            <div>
                <div className="kpi-label">Bindings active</div>
                <div className="kpi-value">{show(bindingsActive)}</div>
                <div className="kpi-sub">{`of ${show(bindingsTotal)} provisioned`}</div>
            </div>
            <div>
                <div className="kpi-label">Messages sent</div>
                <div className="kpi-value">{show(messagesSent)}</div>
                <div className="kpi-sub">{usageIncomplete && messagesSent != null
                    ? `${show(surveyCount)} surveys · known minimum`
                    : `${show(surveyCount)} surveys`}</div>
            </div>
            <div>
                <div className="kpi-label">Spend</div>
                <div className="kpi-value">{show(spend)}</div>
                <div className="kpi-sub">metered channels only</div>
            </div>
            <div>
                <div className="kpi-label">Live now</div>
                <div className="kpi-value">{show(liveNow)}</div>
                <div className="kpi-sub">conversations in flight</div>
            </div>
        </Panel>
    );
}
